import { PlansTableDefinition, PlansTableRowDefinition } from './plans-table/plans-table.model';
import {
  alwaysCheckedCellValue,
  booleanCheckCellValue,
  daysCellValue,
  permissionCheckCellValue,
  priceCellValue,
  rawNumericCellValue,
  requiresOutboundNumberCellValue,
  upToCellValue,
  maxCellValue
} from './plan-features-definition-helpers';

export const keyFeaturesRowsDefinition: PlansTableRowDefinition[] = [
  {
    translateKey: 'PLANS.FEATURES.USERS_LIMIT',
    tooltipText: 'PLANS.FEATURES.USERS_LIMIT_TOOLTIP',
    cellValue: plan => maxCellValue(plan, plan.usersMinimum)
  },
  {
    translateKey: 'PLANS.FEATURES.ADDITIONAL_USER',
    tooltipText: 'PLANS.FEATURES.ADDITIONAL_USER_TOOLTIP',
    cellValue: plan => priceCellValue(plan.pricePerUserDollars)
  },
  {
    translateKey: 'PLANS.FEATURES.PERSONALIZATION',
    tooltipText: 'PLANS.FEATURES.PERSONALIZATION_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.WORKING_HOURS',
    tooltipText: 'PLANS.FEATURES.WORKING_HOURS_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.OUTBOUND_CALLS',
    tooltipText: 'PLANS.FEATURES.OUTBOUND_CALLS_TOOLTIP',
    cellValue: plan => booleanCheckCellValue(!plan.outboundRestricted)
  },
  {
    translateKey: 'PLANS.FEATURES.FREE_PHONE',
    tooltipText: 'PLANS.FEATURES.FREE_PHONE_TOOLTIP',
    cellValue: plan => booleanCheckCellValue(!plan.outboundRestricted)
  },
  {
    translateKey: 'PLANS.FEATURES.RECORDINGS',
    tooltipText: 'PLANS.FEATURES.RECORDINGS_TOOLTIP',
    cellValue: plan => daysCellValue(plan.recordingsStorageDays)
  },
  {
    translateKey: 'PLANS.FEATURES.CALLS_HISTORY',
    tooltipText: 'PLANS.FEATURES.CALLS_HISTORY_TOOLTIP',
    cellValue: plan => daysCellValue(plan.callsHistoryLimit)
  },
  {
    translateKey: 'PLANS.FEATURES.IVR',
    tooltipText: 'PLANS.FEATURES.IVR_TOOLTIP',
    cellValue: plan => booleanCheckCellValue(plan.ivrLimit === undefined || plan.ivrLimit > 0)
  },
  // {
  //   translateKey: 'PLANS.FEATURES.FREE_INBOUND',
  //   tooltipText: 'PLANS.FEATURES.FREE_INBOUND_TOOLTIP',
  //   cellValue: alwaysCheckedCellValue
  // },
  {
    translateKey: 'PLANS.FEATURES.UNLIMITED_MINUTES',
    tooltipText: 'PLANS.FEATURES.UNLIMITED_MINUTES_TOOLTIP',
    cellValue: plan => booleanCheckCellValue(plan.unlimitedCalls)
  }
  // {
  //   translateKey: 'PLANS.FEATURES.IVR',
  //   tooltipText: 'PLANS.FEATURES.IVR_TOOLTIP',
  //   cellValue: plan => upToCellValue(plan.ivrLimit)
  // },
  // {
  //   translateKey: 'PLANS.FEATURES.CALL_DISTRIBUTION',
  //   tooltipText: 'PLANS.FEATURES.CALL_DISTRIBUTION_TOOLTIP',
  //   cellValue: plan => inboundStrategiesCellValue(plan.availableInboundStrategies)
  // },
  // {
  //   translateKey: 'PLANS.FEATURES.CALLS_HISTORY',
  //   tooltipText: 'PLANS.FEATURES.CALLS_HISTORY_TOOLTIP',
  //   cellValue: plan => daysCellValue(plan.callsHistoryLimit)
  // },
  // {
  //   translateKey: 'PLANS.FEATURES.MAX_INTEGRATIONS',
  //   tooltipText: 'PLANS.FEATURES.MAX_INTEGRATIONS_TOOLTIP',
  //   cellValue: plan => rawNumericCellValue(plan.integrationsLimit)
  // },
  // {
  //   translateKey: 'PLANS.FEATURES.MAX_QUEUE',
  //   tooltipText: 'PLANS.FEATURES.MAX_QUEUE_TOOLTIP',
  //   cellValue: plan => rawNumericCellValue(plan.inboundQueueLimit)
  // },
  // Due to Enterprise plan removal
  // {
  //   translateKey: 'PLANS.FEATURES.ADVANCED_DATA_EXPORT',
  //   tooltipText: 'PLANS.FEATURES.ADVANCED_DATA_EXPORT_TOOLTIP',
  //   cellValue: plan => booleanCheckCellValue(plan.isEnterprise)
  // },
  // {
  //   translateKey: 'PLANS.FEATURES.SUPPORT_24',
  //   tooltipText: 'PLANS.FEATURES.SUPPORT_24_TOOLTIP',
  //   cellValue: alwaysCheckedCellValue
  // }
];

export const productFeaturesRowsDefinition: PlansTableRowDefinition[] = [
  {
    translateKey: 'PLANS.FEATURES.WEB_PANEL',
    tooltipText: 'PLANS.FEATURES.WEB_PANEL_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.WIDGET',
    tooltipText: 'PLANS.FEATURES.WIDGET_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.MOBILE',
    tooltipText: 'PLANS.FEATURES.MOBILE_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.WELCOME_MESSAGE',
    tooltipText: 'PLANS.FEATURES.WELCOME_MESSAGE_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.ON_HOLD',
    tooltipText: 'PLANS.FEATURES.ON_HOLD_TOOLTIP',
    cellValue: plan => permissionCheckCellValue(plan, 'ON_HOLD_MESSAGE_PERMISSION')
  },
  {
    translateKey: 'PLANS.FEATURES.CALL_FORWARDING',
    tooltipText: 'PLANS.FEATURES.CALL_FORWARDING_TOOLTIP',
    cellValue: plan => permissionCheckCellValue(plan, 'CALL_FORWARDING_PERMISSION')
  },
  {
    translateKey: 'PLANS.FEATURES.TWO_WAY_FEATURE',
    tooltipText: 'PLANS.FEATURES.TWO_WAY_FEATURE_TOOLTIP',
    cellValue: plan => permissionCheckCellValue(plan, 'TWO_WAY_INTEGRATION_PERMISSION')
  },
  {
    translateKey: 'PLANS.FEATURES.VOICEDROP',
    tooltipText: 'PLANS.FEATURES.VOICEDROP_TOOLTIP',
    cellValue: plan => permissionCheckCellValue(plan, 'VOICE_MAIL_DROP_PERMISSION')
  },
  {
    translateKey: 'PLANS.FEATURES.DND',
    tooltipText: 'PLANS.FEATURES.DND_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.DO_NOT_CALL_LIST',
    tooltipText: 'PLANS.FEATURES.DO_NOT_CALL_LIST_TOOLTIP',
    cellValue: alwaysCheckedCellValue,
    hidden: true
  },
  {
    translateKey: 'PLANS.FEATURES.GROUPS',
    tooltipText: 'PLANS.FEATURES.GROUPS_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.NOTES',
    tooltipText: 'PLANS.FEATURES.NOTES_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.CUSTOMER_CARD',
    tooltipText: 'PLANS.FEATURES.CUSTOMER_CARD_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.CUSTOM_CONTACT',
    tooltipText: 'PLANS.FEATURES.CUSTOM_CONTACT_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.VOICEMAIL',
    tooltipText: 'PLANS.FEATURES.VOICEMAIL_TOOLTIP',
    cellValue: plan => permissionCheckCellValue(plan, 'VOICE_MAIL_PERMISSION')
  },
  {
    translateKey: 'PLANS.FEATURES.CONTACT_TAGS',
    tooltipText: 'PLANS.FEATURES.CONTACT_TAGS_TOOLTIP',
    cellValue: plan => permissionCheckCellValue(plan, 'TAGS_PERMISSION')
  },
  {
    translateKey: 'PLANS.FEATURES.CALL_TAGS',
    tooltipText: 'PLANS.FEATURES.CALL_TAGS_TOOLTIP',
    cellValue: plan => permissionCheckCellValue(plan, 'TAGS_PERMISSION'),
    hidden: true
  },
  {
    translateKey: 'PLANS.FEATURES.LIVE_LISTENING',
    tooltipText: 'PLANS.FEATURES.LIVE_LISTENING_TOOLTIP',
    cellValue: plan => permissionCheckCellValue(plan, 'AGENT_LISTENING_PERMISSION')
  }
];

export const phoneNumbersFeaturesRowsDefinition: PlansTableRowDefinition[] = [
  {
    translateKey: 'PLANS.FEATURES.DIDS_LIMIT',
    tooltipText: 'PLANS.FEATURES.DIDS_LIMIT_TOOLTIP',
    cellValue: plan => rawNumericCellValue(plan.didsLimit)
  },
  {
    translateKey: 'PLANS.FEATURES.INTERNATIONAL_NUMBERS',
    tooltipText: 'PLANS.FEATURES.INTERNATIONAL_NUMBERS_TOOLTIP',
    cellValue: plan => requiresOutboundNumberCellValue(plan)
  },
  {
    translateKey: 'PLANS.FEATURES.OWN_NUMBER',
    tooltipText: 'PLANS.FEATURES.OWN_NUMBER_TOOLTIP',
    cellValue: plan => requiresOutboundNumberCellValue(plan)
  },
  {
    translateKey: 'PLANS.FEATURES.PORTING',
    tooltipText: 'PLANS.FEATURES.PORTING_TOOLTIP',
    cellValue: plan => requiresOutboundNumberCellValue(plan)
  },
  {
    translateKey: 'PLANS.FEATURES.TOLL_FREE',
    tooltipText: 'PLANS.FEATURES.TOLL_FREE_TOOLTIP',
    cellValue: plan => permissionCheckCellValue(plan, 'TOLL_FREE_NUMBERS_PERMISSION')
  }
];

export const appsAndIntegrationsRowsDefinitions: PlansTableRowDefinition[] = [
  {
    translateKey: 'PLANS.FEATURES.INTEGRATIONS_LIMIT',
    tooltipText: 'PLANS.FEATURES.INTEGRATIONS_LIMIT_TOOLTIP',
    cellValue: plan => rawNumericCellValue(plan.integrationsLimit)
  },
  {
    translateKey: 'PLANS.FEATURES.PIPEDRIVE',
    tooltipText: 'PLANS.FEATURES.PIPEDRIVE_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.MAGENTO',
    tooltipText: 'PLANS.FEATURES.MAGENTO_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.HUBSPOT',
    tooltipText: 'PLANS.FEATURES.HUBSPOT_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.ZENDESK',
    tooltipText: 'PLANS.FEATURES.ZENDESK_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.INTEGROMAT',
    tooltipText: 'PLANS.FEATURES.INTEGROMAT_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.SHOPIFY',
    tooltipText: 'PLANS.FEATURES.SHOPIFY_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.LIVECHAT',
    tooltipText: 'PLANS.FEATURES.LIVECHAT_TOOLTIP',
    cellValue: alwaysCheckedCellValue,
    soon: true
  },
  {
    translateKey: 'PLANS.FEATURES.SHOPER',
    tooltipText: 'PLANS.FEATURES.SHOPER_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.API',
    tooltipText: 'PLANS.FEATURES.API_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.WEBHOOKS',
    tooltipText: 'PLANS.FEATURES.WEBHOOKS_TOOLTIP',
    cellValue: plan => booleanCheckCellValue(plan.webhooksLimit === undefined || plan.webhooksLimit > 0)
  },
  {
    translateKey: 'PLANS.FEATURES.ZAPIER',
    tooltipText: 'PLANS.FEATURES.ZAPIER_TOOLTIP',
    cellValue: alwaysCheckedCellValue,
    soon: true,
    hidden: true
  }
];

export const reportingRowsDefinitions: PlansTableRowDefinition[] = [
  {
    translateKey: 'PLANS.FEATURES.REAL_TIME_DASHBOARD',
    tooltipText: 'PLANS.FEATURES.REAL_TIME_DASHBOARD_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.SIMPLE_EXPORT',
    tooltipText: 'PLANS.FEATURES.SIMPLE_EXPORT_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.RECORDINGS',
    tooltipText: 'PLANS.FEATURES.RECORDINGS_TOOLTIP',
    cellValue: plan => booleanCheckCellValue(plan.recordingsStorageDays === undefined || plan.recordingsStorageDays > 0)
  }
  // Due to Enterprise plan removal
  // {
  //   translateKey: 'PLANS.FEATURES.CUSTOM_REPORTS',
  //   tooltipText: 'PLANS.FEATURES.CUSTOM_REPORTS_TOOLTIP',
  //   cellValue: plan => booleanCheckCellValue(plan.isEnterprise)
  // }
];

export const customerSupportRowsDefinitions: PlansTableRowDefinition[] = [
  {
    translateKey: 'PLANS.FEATURES.PHONE_SUPPORT',
    tooltipText: 'PLANS.FEATURES.PHONE_SUPPORT_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.CHAT_SUPPORT',
    tooltipText: 'PLANS.FEATURES.CHAT_SUPPORT_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.MAIL_SUPPORT',
    tooltipText: 'PLANS.FEATURES.MAIL_SUPPORT_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.KNOWLEDGE_BASE',
    tooltipText: 'PLANS.FEATURES.KNOWLEDGE_BASE_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.ONBOARDING',
    tooltipText: 'PLANS.FEATURES.ONBOARDING_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  },
  {
    translateKey: 'PLANS.FEATURES.SECURITY',
    tooltipText: 'PLANS.FEATURES.SECURITY_TOOLTIP',
    cellValue: alwaysCheckedCellValue
  }
];

export const plansTables: PlansTableDefinition[] = [
  {
    headerKey: 'PLANS.FEATURES.KEY_FEATURES_HEADER',
    rows: keyFeaturesRowsDefinition
  },
  {
    headerKey: 'PLANS.FEATURES.PRODUCTIVITY_HEADER',
    rows: productFeaturesRowsDefinition
  },
  {
    headerKey: 'PLANS.FEATURES.PHONE_NUMBERS_HEADER',
    rows: phoneNumbersFeaturesRowsDefinition
  },
  {
    headerKey: 'PLANS.FEATURES.INTEGRATIONS_HEADER',
    rows: appsAndIntegrationsRowsDefinitions
  },
  {
    headerKey: 'PLANS.FEATURES.REPORTING_HEADER',
    rows: reportingRowsDefinitions
  },
  {
    headerKey: 'PLANS.FEATURES.CUSTOMER_SUPPORT_HEADER',
    rows: customerSupportRowsDefinitions
  }
];
